import React, { useState, useEffect } from 'react'
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
import Loader from '../../../../presentationals/Loader/Loader.component';
import PiePage from '../CommonComponents/PiePage.component'
import InputField from '../CommonComponents/InputMUI'
import SelectField from '../CommonComponents/SelectMUI';
import { getcommunityDetailsByTypeById, SaveUpdateHubByData } from './ActionCreator';
import Popup from '../../../../presentationals/Popup/Popup.component'

const activeData = [
    { name: "Yes", code: true },
    { name: "No", code: false },
]

export default function Add({ handleTabchange, EditData, pageViewHandler }) {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [errors, setErrors] = useState([])
    const [hubManagerCommunityIdData, sethubManagerCommunityIdData] = useState([])
    const [objectDataNew, setobjectDataNew] = useState({
        hubName: "",
        hubManagerCommunityId: "",
        address: "",
        city: "", pincode: "", state: "", latitude: "", longitude: "", active: ""
    })

    useEffect(() => {
        getcommunityDetailsByTypeByIdFn()
    }, [])
    useEffect(() => {
        if (EditData?.id || EditData?.hubId) {
            setobjectDataNew({
                hubName: EditData?.hubName || "",
                hubManagerCommunityId: EditData?.hubManagerCommunityId || "",
                address: EditData?.address || "",
                city: EditData?.city || "", pincode: EditData?.pincode || "",
                 state: EditData?.state || "", latitude: EditData?.latitude || "",
                  longitude: EditData?.longitude || "", active: EditData?.active || ""
            })

        } else {
            setobjectDataNew({
                hubName: "",
                hubManagerCommunityId: "",
                address: "",
                city: "", pincode: "", state: "", latitude: "", longitude: "", active: ""
            })
        }
    }, [EditData])

    const getcommunityDetailsByTypeByIdFn = () => {
        setLoader(true)
        getcommunityDetailsByTypeById("Amu Agent", callback => {
            setLoader(false)
            const updatedArray = []
            const ar = callback?.data?.length > 0 ? callback?.data?.map((el) => {
                const obj = { name: el?.name, code: el?.communityId }
                updatedArray?.push(obj)
            }) : []
            sethubManagerCommunityIdData(updatedArray || [])
        })
    }

    const inputChange = (e, type) => {

        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))

        setErrors(prev => ({ ...prev, [type]: "" }))
    }

    const saveHandler = (type) => {
        if (type == "close") {
            handleTabchange("list", "")
        } else if (type == "save") {
            const isValid = handleFormValidation(objectDataNew)
            if (!isValid) return
            console.log("Form data ready to submit:", objectDataNew)
            setLoader(true)
            const obj = {...objectDataNew}
            if(EditData?.id || EditData?.hubId){
                obj.hubId = EditData?.hubId
            }
            SaveUpdateHubByData(obj, callback => {
                setLoader(false)
                if (callback?.message == "success") {
                    setobjectDataNew({
                        hubName: "",
                        hubManagerCommunityId: "",
                        address: "",
                        city: "", pincode: "", state: "", latitude: "", longitude: "", active: ""
                    })
                    setpopup({ show: true, popupStatus: 'Hub Saved Successfully' })
                    setTimeout(() => {
                        saveHandler("close")
                    }, 5000)
                } else {
                    setpopup({ show: true, popupStatus: `Error: ${callback?.error?.errorMessage || ""} ` })
                }
                removePopup()

            })
        }
    }

    const handleFormValidation = (data) => {
        let newErrors = {}

        if (!data.hubName?.trim()) newErrors.hubName = "Hub Name is required"
        if (!data.hubManagerCommunityId) newErrors.hubManagerCommunityId = "Please select a Hub Manager"
        if (!data.address?.trim()) newErrors.address = "Address is required"
        if (!data.state?.trim()) newErrors.state = "State is required"
        if (!data.city?.trim()) newErrors.city = "City is required"
        if (!data.pincode?.trim()) newErrors.pincode = "Pincode is required"
        if (!data.latitude?.trim()) newErrors.latitude = "Latitude is required"
        if (!data.longitude?.trim()) newErrors.longitude = "Longitude is required"
        if (data.active === "") newErrors.active = "Please select Active status"

        if (data.pincode && !/^\d{6}$/.test(data.pincode)) {
            newErrors.pincode = "Pincode must be a 6-digit number"
        }


        if (data.latitude && !/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(data.latitude)) {
            newErrors.latitude = "Enter a valid latitude (-90 to 90)"
        }

        if (data.longitude && !/^[-+]?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?)$/.test(data.longitude)) {
            newErrors.longitude = "Enter a valid longitude (-180 to 180)"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 3000)
    }
    return (
        <>
            <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                {/* <h5 style={{ cursor: 'pointer' }}>Back</h5> */}
                <h5 style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Back</h5>
            </div>

            <div className="communitySection">
                <div className='container hoverNone card'>
                    {loader ?
                        <Loader />
                        : null}

                    {
                        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
                    }


                    <PiePage
                        totalPage={1}
                        currentPage={1}
                        heading={'Add / Update Hub'}
                    />

                    <div className='row' style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Hub Name"
                                variant="outlined"
                                value={objectDataNew.hubName}
                                name="hubName"
                                id="hubName"
                                type="text"
                                onChange={e => inputChange(e, 'hubName')}
                                size="small" required={true}

                            />
                            {
                                errors?.hubName &&
                                <div style={{ fontSize: '10px' }} id="hubNameHelp" className="form-text text-danger">{errors?.hubName}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <SelectField
                                value={objectDataNew.hubManagerCommunityId}
                                label="Select Hub Manager"
                                onChange={e => inputChange(e, 'hubManagerCommunityId')}
                                name="hubManagerCommunityId"
                                data={hubManagerCommunityIdData?.length > 0 ? hubManagerCommunityIdData : []}
                                size={'small'}
                                required={true}
                            />
                            {
                                errors?.hubManagerCommunityId &&
                                <div style={{ fontSize: '10px' }} id="hubManagerCommunityIdHelp" className="form-text text-danger">{errors?.hubManagerCommunityId}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Address"
                                variant="outlined"
                                value={objectDataNew.address}
                                name="address"
                                id="address"
                                type="text"
                                onChange={e => inputChange(e, 'address')}
                                size="small" required={true}

                            />
                            {
                                errors?.address &&
                                <div style={{ fontSize: '10px' }} id="addressHelp" className="form-text text-danger">{errors?.address}</div>
                            }
                        </div>



                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="State"
                                variant="outlined"
                                value={objectDataNew.state}
                                name="state"
                                id="state"
                                type="text"
                                onChange={e => inputChange(e, 'state')}
                                size="small" required={true}

                            />
                            {
                                errors?.state &&
                                <div style={{ fontSize: '10px' }} id="stateHelp" className="form-text text-danger">{errors?.state}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="City"
                                variant="outlined"
                                value={objectDataNew.city}
                                name="city"
                                id="city"
                                type="text"
                                onChange={e => inputChange(e, 'city')}
                                size="small" required={true}

                            />
                            {
                                errors?.city &&
                                <div style={{ fontSize: '10px' }} id="cityHelp" className="form-text text-danger">{errors?.city}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Pincode"
                                variant="outlined"
                                value={objectDataNew.pincode}
                                name="pincode"
                                id="pincode"
                                type="number"
                                onChange={e => inputChange(e, 'pincode')}
                                size="small" required={true}

                            />
                            {
                                errors?.pincode &&
                                <div style={{ fontSize: '10px' }} id="pincodeHelp" className="form-text text-danger">{errors?.pincode}</div>
                            }
                        </div>
                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Latitude"
                                variant="outlined"
                                value={objectDataNew.latitude}
                                name="latitude"
                                id="latitude"
                                type="text"
                                onChange={e => inputChange(e, 'latitude')}
                                size="small" required={true}

                            />
                            {
                                errors?.latitude &&
                                <div style={{ fontSize: '10px' }} id="latitudeHelp" className="form-text text-danger">{errors?.latitude}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Longitude"
                                variant="outlined"
                                value={objectDataNew.longitude}
                                name="longitude"
                                id="longitude"
                                type="text"
                                onChange={e => inputChange(e, 'longitude')}
                                size="small" required={true}

                            />
                            {
                                errors?.longitude &&
                                <div style={{ fontSize: '10px' }} id="longitudeHelp" className="form-text text-danger">{errors?.longitude}</div>
                            }
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <SelectField
                                value={objectDataNew.active}
                                label="Is Active"
                                onChange={e => inputChange(e, 'active')}
                                name="active"
                                data={activeData}
                                size={'small'}
                                required={true}
                            />
                            {
                                errors?.active &&
                                <div style={{ fontSize: '10px' }} id="longitudeHelp" className="form-text text-danger">{errors?.active}</div>
                            }
                        </div>
                    </div>


                    <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                        {/* <div className="form-text text-danger">{responseMsg}</div> */}
                        <div className="col-12 text-center">

                            <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                            <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
